var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: {
              propsData: {
                isCountry: false,
                adChannel: false,
                adPlacement: false
              }
            },
            on: { searchChange: _vm.searchChange }
          })
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleSource()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("add")))]
              ),
              _vm.tableData.length
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.exportdata }
                    },
                    [_vm._v(_vm._s(_vm.$t("export")))]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.searchClick(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.tableData.length
        ? _c(
            "el-table",
            {
              directives: [
                {
                  name: "sticky-table-header",
                  rawName: "v-sticky-table-header",
                  value: 0,
                  expression: "0"
                },
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.reqLoading,
                  expression: "reqLoading"
                }
              ],
              ref: "tableRef",
              attrs: { id: "tableRef", data: _vm.tableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: _vm.$t("idLabel"), width: "60" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "game_reveal",
                  label: _vm.$t("game"),
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "platform_reveal",
                  label: _vm.$t("platform"),
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "channel_reveal",
                  label: _vm.$t("channel"),
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "pkg_reveal",
                  label: _vm.$t("pkg"),
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "timestamp", label: _vm.$t("date") }
              }),
              _c("el-table-column", {
                attrs: { prop: "email_list", label: _vm.$t("emailList") }
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("operation"),
                  width: "160",
                  align: "center",
                  fixed: "right"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("div", { staticClass: "x-c" }, [
                            _c(
                              "div",
                              {
                                staticClass: "controlsBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.handleSource(scope.row)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("modify")))]
                            ),
                            _c("div", { staticClass: "controlsBtn-vertical" }),
                            _c(
                              "div",
                              {
                                staticClass: "controlsBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.handleDelete(scope.row)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("delete")))]
                            )
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2884086746
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm.tableData.length
        ? _c("el-pagination", {
            attrs: {
              layout: "total,sizes, prev, pager, next",
              "current-page": _vm.searchData.page,
              total: _vm.total
            },
            on: {
              "current-change": _vm.searchClick,
              "size-change": _vm.sizeChange
            }
          })
        : _vm._e(),
      _c("addNotic", {
        ref: "addWayConfig",
        attrs: { showing: _vm.showing },
        on: {
          refreshDataList: function($event) {
            return _vm.searchClick(_vm.searchData.page)
          },
          changeShow: _vm.changeShow
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }